<div class="stepper">
  <p-steps
    [model]="stepList"
    [activeIndex]="activeIndex"
    [readonly]="readOnly"
  ></p-steps>
</div>
